/** @module Apparel/NewColorMaterialFromMaterial **/
define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml",
], function(declare, New, xml) {

	const PROPAGATE = "Propagate3DMaterial";
	const PROPAGATE_FIELD = "3DPropagate3DMaterials";
	const COLOR_SPECIFICATION = "ColorSpecification";
	const PRODUCT_SOURCE = "ProductSource";
	const PRODUCT_SOURCES = "ProductSources";

	return declare(New, {

		/**
		 * Call server Java operation to create Color Material and propagate 3D Material if needed
		 * @param {array} val
		 */
		toWriterRequest: function() {
			const formData = this.getFormData();
			const productSourceFieldValue = this.getParent().ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP" ? formData.getFieldValue(PRODUCT_SOURCE, true) : null;
			// Create Color Material using server operation
			return this.inherited(arguments)
				.addParameter(PROPAGATE, xml.ATTR_BOOLEAN, formData.getFieldValue(PROPAGATE_FIELD, true))
				.addParameter(COLOR_SPECIFICATION, xml.ATTR_REF, formData.getFieldValue(COLOR_SPECIFICATION, true))
				.addParameter(xml.ATTR_NAME, xml.ATTR_STRING, formData.getFieldValue(xml.ATTR_NAME, true))
				.addParameter(PRODUCT_SOURCES, xml.ATTR_REFLIST, productSourceFieldValue);
		}
	});
});